import { createAction } from 'redux-actions'

const HARDWARE_KEY_UP = 'HARDWARE_KEY_UP'
const HARDWARE_KEY_DOWN = 'HARDWARE_KEY_DOWN'

const WINDOW_BLUR = 'WINDOW_BLUR'
const RELEASE_PRESSED_KEYS = 'RELEASE_PRESSED_KEYS'

const MOUSE_UP = 'MOUSE_UP'
const MOUSE_DOWN = 'MOUSE_DOWN'
const MOUSE_MOVE = 'MOUSE_MOVE'
const MOUSE_WHEEL = 'MOUSE_WHEEL'

const NOTIFY_SEND_MOUSE_EVENT = 'NOTIFY_SEND_MOUSE_EVENT'
const NOTIFY_SEND_KEYBOARD_EVENT = 'NOTIFY_SEND_KEYBOARD_EVENT'
const NOTIFY_SEND_COMMAND = 'NOTIFY_SEND_COMMAND'

const SET_MODIFIER_KEY_STATE = 'SET_MODIFIER_KEY_STATE'
const UNCHECK_ACTIVE = 'UNCHECK_ACTIVE'
const UNCHECK_ALWAYS_ON = 'UNCHECK_ALWAYS_ON'
const NOTIFY_MONITORS = 'NOTIFY_MONITORS'

const SWITCH_FIT_TO_SCREEN = 'SWITCH_FIT_TO_SCREEN'

const TB_SHOW_MODAL = 'TB_SHOW_MODAL'
const TB_HIDE_MODAL = 'TB_HIDE_MODAL'
const TB_CLOSE_MODAL = 'TB_CLOSE_MODAL'

export const hardwareKeyUp = createAction(HARDWARE_KEY_UP)
export const hardwareKeyDown = createAction(HARDWARE_KEY_DOWN)

export const windowBlur = createAction(WINDOW_BLUR)
export const releasePressedKeys = createAction(RELEASE_PRESSED_KEYS)

export const mouseUp = createAction(MOUSE_UP)
export const mouseDown = createAction(MOUSE_DOWN)
export const mouseMove = createAction(MOUSE_MOVE)
export const mouseWheel = createAction(MOUSE_WHEEL)

export const notifySendMouseEvent = createAction(NOTIFY_SEND_MOUSE_EVENT)
export const notifySendKeyboardEvent = createAction(NOTIFY_SEND_KEYBOARD_EVENT)
export const notifySendKeyboardEventDebug =
  createAction(NOTIFY_SEND_KEYBOARD_EVENT, (param) => param.payload, (param) => param.meta)
export const notifySendCommand = createAction(NOTIFY_SEND_COMMAND)
export const notifyMonitors = createAction(NOTIFY_MONITORS)

export const setModifierKeyState = createAction(SET_MODIFIER_KEY_STATE)
export const uncheckActive = createAction(UNCHECK_ACTIVE)
export const uncheckAlwaysOn = createAction(UNCHECK_ALWAYS_ON)

export const switchFitToScreen = createAction(SWITCH_FIT_TO_SCREEN)

export const TriState = Object.freeze({ Inactive: 0, Active: 1, AlwaysOn: 2 })
export const Platforms = Object.freeze({ MAC_OS: 'macos', WINDOWS: 'windows', IOS: 'ios' })

export const tbShowModal = createAction(TB_SHOW_MODAL)
export const tbHideModal = createAction(TB_HIDE_MODAL)
export const tbCloseModal = createAction(TB_CLOSE_MODAL)
